import { render, staticRenderFns } from "./gear.vue?vue&type=template&id=2b65da12&"
import script from "./gear.vue?vue&type=script&lang=js&"
export * from "./gear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports